export default __webpack_public_path__ + "static/media/018-Christmas tree.f600e4b9.svg";